import { generalServiceV1API } from '@/store/api-instance'
import { IGetAvailableDateRequest, IGetDeliveryAvailableDateRequest } from '../interfaces/getAvailableDates/IGetAvailableDateRequest'
import { AxiosResponse } from 'axios'

async function getAvailableDateAPI (queryParams: IGetAvailableDateRequest) {
  const response: AxiosResponse = await generalServiceV1API.get('orders/GetFirstAvailableDate', { params: queryParams })
  return response.data
}

async function getDeliveryAvailableDateAPI (queryParams: IGetDeliveryAvailableDateRequest) {
  const response: AxiosResponse = await generalServiceV1API.get('orders/GetDeliveryAvailableDate', { params: queryParams })
  return response.data
}

async function fetchOrderReason (dto: {soldToId: string, deliveryDate: string}): Promise<any> {
  const response: AxiosResponse = await generalServiceV1API.get<any>('orders/GetOrderReason', { params: dto })
  return response.data
}

async function fetchOrderType (dto: {soldToId: string}): Promise<any> {
  const response: AxiosResponse = await generalServiceV1API.get<any>('orders/GetOrderType', { params: dto })
  return response.data
}

export {
  fetchOrderReason,
  fetchOrderType,
  getAvailableDateAPI,
  getDeliveryAvailableDateAPI
}
